import React from 'react';
import TimelineChart from './TimelineChart';
import AccountSummary from './AccountSummary';
import NextPayments from './NextPayments';
import LastMovements from './LastMovements';
import Calendar from './Calendar';
import "./HomeClientNew.scss"

export default function HomeClientNew({ isMobile, mainProps, showSidebar }) {
    const { main, mainLoading, mainError } = mainProps;

    return (
        <>
            <div
                className="container-fluid bg-col transition-width"
                style={
                    !isMobile
                        ? {
                            width: showSidebar ? 'calc(100% - 332px)' : '100%',
                            marginLeft: 0,
                            marginRight: 'auto',
                            transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                        } : {}
                }
            >
                <div className="row">
                    <main className="col-md-12 p-0">
                        <TimelineChart main={main} isMobile={isMobile} />

                        <div className='p-3'>
                            <div className="row mt-5">
                                <div className="col-md-6 p-0" style={{ borderRight: "2px solid #EFEFEF" }}>
                                    <LastMovements main={main} />
                                    <NextPayments main={main} isMobile={isMobile} />
                                </div>
                                <div className="col-md-6 p-0">
                                    <AccountSummary main={main} />
                                    <Calendar />
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div >
        </>
    );
}
